import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'

// Font Awesome

// Appt Components
import Box from '../../../components/simple/box/Box'
import DataTable from '../../../components/simple/dataTable/DataTable.js'
import Text from '../../../components/simple/text/Text'
import Divider from '../../../components/simple/divider/Divider'

// Services
import LocalStorageService from '../../../services/LocalStorageService'

import moment from 'moment'
import Anchor from '../../../components/simple/anchor/Anchor.js'
import ActionButton from '../../../components/compound/actionButton/ActionButton.js'

const RelatedClickers = (props) => {
  const apiToken = LocalStorageService.get('apiToken')
  const activeOrg = LocalStorageService.get('activeOrg')

  const [submissions, setSubmissions] = useState([])
  const [responses, setResponses] = useState([])

  const navigate = useNavigate()

  const [sort, setSort] = useState({
      property: 'clickerDate',
      direction: 'desc'
    })

  const getClickerDateValue = datum => {
    if (datum?.clickerDate) {
      return datum.clickerDate
    }

    if (datum?.createdAt) {
      return moment(datum.createdAt).format('YYYY-MM-DD')
    }

    return ''
  }

  const getClickerTimeValue = datum => {

    let dateField = datum?.clickerDate || datum?.createdAt

    if (dateField) {
      return moment(dateField).format('HH:mm')
    }
    return ''
  }

  const formatClickerDate = value => {
    if (!value) {
      return ''
    }

    return moment(value).format('DD/MM/YYYY')
  }

  const resultColumns = [
    {
        property: 'clickerDate',
        label: 'Date',
        header: <Text>Date</Text>,
        render: datum => (
          <Text>{formatClickerDate(getClickerDateValue(datum))}</Text>
        )
      },
      {
        property: 'user',
        label: 'Child',
        header: <Text>Child</Text>,
        render: datum => (
          <Anchor href={`/serviceuser/${datum.userId}/edit`} color='primary'>
            <Text>{datum.firstname || ''} {datum.lastname || ''}</Text>
          </Anchor>
        )
      },
    {
      property: 'subType',
      label: 'Type',
      header: <Text>Type</Text>
    },
    {
      property: 'yearGroup',
      label: 'Year Group',
      header: <Text>Year Group</Text>,
      render: datum => (
        <Anchor href={`/serviceusers/year/${datum.yearGroup}`} color='primary'>
          <Text>{`${datum.yearGroup || ''}`}</Text>
        </Anchor>
      ),
    },
  ]

  const [showIncidents, setShowIncidents] = useState(false)

  // const downloadCSV = () => {

  //   // generate a CSV of data from submissions and download it
  //   const csvRows = []
  //   const headers = resultColumns.filter(c => c.label).map(c => c.label)
  //   csvRows.push(headers.join(','))
  //   submissions.forEach(submission => {
  //     const row = []
  //     headers.forEach(header => {
  //       if (header === 'Incident No') {
  //         row.push(`besmart-${submission.id}`)
  //       } else if (header === 'Child') {
  //         row.push(submission.user)
  //       } else if (header === 'Year Group') {
  //         row.push(submission.yearGroup)
  //       } else if (header === 'Student Group') {
  //         row.push(submission.studentGroup)
  //       } else{
  //         row.push('')
  //       }
  //     })
  //     csvRows.push(row.join(','))
  //   })
  //   const csvString = csvRows.join('\n')
  //   const blob = new Blob([csvString], { type: 'text/csv' })
  //   const url = URL.createObjectURL(blob)
  //   window.open(url, '_blank')
  // }

  const downloadCSV = () => {
    const csvRows = []
    const submissions = props.results || []

    const headers = [
      'Date',
      'Time',
      'Child',
      'Type',
      'Year Group'
    ]
    csvRows.push(headers.join(','))

    submissions.forEach(datum => {
      let row = [
        `${formatClickerDate(getClickerDateValue(datum))}`,
        `${getClickerTimeValue(datum)}`,
        `${datum.firstname || ''} ${datum.lastname || ''}`,
        `${datum.subType || ''}`,
        `${datum.yearGroup || ''}`
      ]

      // escape quotes by doubling them, then wrap in quotes to preserve commas and line breaks
      row = row.map(item => `"${item.replace(/"/g, '""')}"`)
      csvRows.push(row.join(','))
    })

    const csvString = csvRows.join('\n')
    const blob = new Blob([csvString], { type: 'text/csv' })
    const url = URL.createObjectURL(blob)
    // window.open(url, '_blank')


    let fileLink = document.createElement('a');
    fileLink.href = url;
    fileLink.download = 'BeSmart - Related Clickers - ' + moment().format('DD-MM-YYYY') + '.csv';
    fileLink.click();

  }


  return (
    <Box background='white' direction='column' gap='small' round='small' margin={{ top: 'small', bottom: 'small'}}>
         <Box
            gap='small'
            margin={{ horizontal: 'small' }}
            pad={{ horizontal: 'xsmall', top: 'none' }}
            round='small'
        >

            <Box direction='row' justify='between' margin={{ top: 'medium', bottom: 'medium' }}>
                <Text margin={{ top: 'small', bottom: 'small' }} size='xlarge'>Additional Actions</Text>
                <Box alignSelf='center' direction='row' gap='none'>
                    <ActionButton size='small' onClick={() => { setShowIncidents(!showIncidents) }} label={showIncidents ? 'Hide Related Clickers' : 'Show Related Clickers'} primary />
                    <ActionButton size='small' onClick={() => { downloadCSV() }} label='Download CSV' primary />
                    {props?.additionalButtons}
                </Box>

            </Box>
            {showIncidents && <>
                <Divider />
                <Box direction='column' gap='xsmall' margin={{ top: 'none' }}>
                        <Text margin={{ top: 'small', bottom: 'small' }} size='xlarge'>Related Clickers</Text>

                        <Text margin={{ top: 'small', bottom: 'small' }} size='medium'>First 250 Results ({props.results?.length || 0} found)</Text>
                        {props.results?.length > 0 && <DataTable
                            columns={resultColumns}
                            data={props.results}
                            primaryKey='id'
                            sort={sort}
                            onSort={setSort}
                        />}
                        {!props.results?.length > 0 && <Text color='#666'>- No results to display -</Text>}

                </Box>
            </>}
        </Box>
    </Box>
  )
}

export default RelatedClickers
